import { controlPlateField, countryCodeField } from './../parker-registration-report.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ClientDTO,
  DateRangeParameterDTO,
  ParkerRegistrationReportDTO,
  ParkerRegistrationsReportParameterDTO,
  ParkerRegistrationType,
} from '../../../../../base/models/models.swagger.generated';
import { UntypedFormBuilder } from '@angular/forms';
import { ClientService } from '../../../../../base/services/client/client.service';
import { ParkerRegistrationReportService } from '../parker-registration-report.service';
import { GridConstantsFactory } from '../../../../../base/shared/syncfusion/grid-constants-factory';
import { SaveOptions } from '../../../reports-footer/save-options';
import { reportsRoute } from '../../../../../core/routing/route-names';
import { Router } from '@angular/router';
import { GridComponent, GridModule } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from '../../../../../base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from '../../../../../base/spinner/spinner.service';
import { ReportsFooterComponent } from '../../../reports-footer/reports-footer.component';
import { DateTime } from 'luxon';
import { TranslateModule } from '@ngx-translate/core';
import { ParkerRegistrationFormComponent } from '../parker-registration-form/parker-registration-form.component';
import { TitleBarComponent } from '../../../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-parker-registration-report',
    templateUrl: './parker-registration-report.component.html',
    styleUrls: ['./parker-registration-report.component.scss'],
    imports: [
        TitleBarComponent,
        ParkerRegistrationFormComponent,
        GridModule,
        ReportsFooterComponent,
        TranslateModule,
    ]
})
export class ParkerRegistrationReportComponent implements OnInit {

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild(ReportsFooterComponent) public footer: ReportsFooterComponent;

  public controlPlateField = controlPlateField;
  public countryCodeField = countryCodeField;

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public data: DataManager;
  public filterForm = this.fb.group({
    startDate: [DateTime.now().startOf('month').toJSDate()],
    endDate: [DateTime.now().endOf('month').toJSDate()],
    parkerRegistrationType: [null],
  });

  public pageSettings = GridConstantsFactory.createStandardPageSettings();
  public ParkerRegistrationType: ParkerRegistrationType;

  constructor(public clientService: ClientService,
              private fb: UntypedFormBuilder,
              private router: Router,
              private spinnerService: SpinnerService,
              private parkerRegistrationReportService: ParkerRegistrationReportService) {
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.parkerRegistrationReportService, this.spinnerService),
    });
    if (this.selectedClient) {
      this.searchReports();
    }
  }

  public searchReports(): void {
    if (this.filterForm.get('startDate').value && this.filterForm.get('endDate').value && this.selectedClient?.id) {
      this.parkerRegistrationReportService.parameters = this.createParkerRegistrationReportParameters();
      try {
        this.grid?.refresh();
      } catch (e) {
        // Ignore error when grid is in transition state
      }
    }
  }

  public saveReport(saveOptions: SaveOptions): void {
    this.spinnerService.show();

    const parkerRegistrationsReportParameterDTO = this.createParkerRegistrationReportParameters();

    this.parkerRegistrationReportService.exportReport(parkerRegistrationsReportParameterDTO, saveOptions)
      .subscribe(savedReportFileDTO => {
        this.spinnerService.hide();
        if (saveOptions.saveReport) {
          this.router.navigate([reportsRoute]);
        } else {
          this.footer.downloadFile(savedReportFileDTO);
        }
      });
  }

  public formatType(type: any): string {
    return 'i18n.domain.parker-registration.ParkerRegistrationType.' + ParkerRegistrationType[type];
  }

  private createParkerRegistrationReportParameters(): ParkerRegistrationsReportParameterDTO {
    return new ParkerRegistrationsReportParameterDTO({
      dateRange: new DateRangeParameterDTO({
        startDate: DateTime.fromJSDate(this.filterForm.get('startDate').value).startOf('day').toFormat('yyyy-MM-dd'),
        endDate: DateTime.fromJSDate(this.filterForm.get('endDate').value).startOf('day').toFormat('yyyy-MM-dd')
      }),
      parkerRegistrationType: this.filterForm.get('parkerRegistrationType').value,
    });
  }

  public getControlPlate(data: ParkerRegistrationReportDTO): string {
    return data.knownTag? data.knownTag.operationalControlPlate : data.unknownParkerTagOperationalControlPlateNumber;
  }

  public getCountryCode(data: ParkerRegistrationReportDTO): string {
    return data.knownTag ? data.knownTag.countryCode : data.unknownParkerTagCountryCode;
  }
}
